<script>
  import CircleImg from "../atoms/CircleImg.vue";
  import Paragraph from "../atoms/Paragraph.vue";
  import Tooltip from "../atoms/ToolTip.vue";

  export default {
    name: "rowCard",
    components: { CircleImg, Paragraph, Tooltip },
    props: {
      subTitle: { type: String, default: "" },
      title: { type: String, default: "" },
      alt: { type: String, default: "" },
      img: { type: String, default: "" },
      styleImg: {
        type: Object,
        default: () => ({
          width: "20px",
          height: "20px",
          border: "solid 1px #bd0909",
        }),
      },
      colorHover: { type: String, default: "" },
      item: "",
      icon: { type: String, default: "closeIcon" },
      showIcon: { type: Boolean, default: false },
      useIconic: { type: Boolean, default: false },
      canShowTooltip: { type: Boolean, default: false },
      tooltipText: { type: String, default: "" },
      showBackground: { type: Boolean, default: false },
      variant: { type: String, default: "default" },
    },
    data() {
      return {
        showImg: true,
        showTooltip: false,
      };
    },
    methods: {
      onClick() {
        this.$emit("onClick", this.item);
      },
      handleMouseInteraction(stateImg, stateTooltip) {
        if (this.canShowTooltip) {
          this.showTooltip = stateTooltip;
        }
        if (this.showIcon) {
          this.showImg = stateImg;
        }
      },
    },
  };
</script>

<template>
  <div
    :class="`rowCard rowCard--${variant} ${showBackground ? 'rowCard--background' : ''}`"
    :style="{ '--hover-color': colorHover }"
    @click="onClick"
    @mouseenter="handleMouseInteraction(false, true)"
    @mouseleave="handleMouseInteraction(true, false)">
    <div class="rowCard__imgs">
      <transition name="fade" mode="out-in">
        <CircleImg v-if="showImg" :img="img" :style="styleImg" :item="item" :useIconic="useIconic" key="main-img" />
        <CircleImg v-else :img="icon" :style="styleImg" :item="item" variant="xIcon" :useIconic="true" key="icon-img" />
      </transition>
      <Tooltip v-show="showTooltip" :text="tooltipText" />
    </div>
    <div class="rowCard__text" v-if="title || subTitle">
      <Paragraph className="rowCard__title" v-if="title" :text="title" />
      <Paragraph className="rowCard__subTitle" v-if="subTitle" :text="subTitle" />
    </div>
  </div>
</template>

<style lang="scss">
  .rowCard {
    @include Flex(row, flex-start, center);
    width: 100%;
    gap: 6px;
    padding: 5px 7px;
    border-radius: 50px;
    cursor: pointer;

    &:hover {
      background-color: var(--hover-color);
    }

    &__title {
      color: #171717;
      font-weight: 400;
      font-size: 16px;
      line-height: 1.1;
    }
    &__imgs {
      position: relative;
    }
    &__subTitle {
      color: $primary-color;
      margin-left: 2px;
      font-size: 10px;
      font-style: normal;
      line-height: normal;
      font-family: $sec_fontBold;
    }

    &__text {
      @include Flex(column, flex-start, flex-start);
    }

    &--nonBorderRadius {
      border-radius: 0;
    }

    &--background {
      background-color: #f0f0f0;
      &:hover {
        background-color: var(--hover-color);
      }
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.1s ease;
    }

    .fade-enter-from,
    .fade-leave-to {
      opacity: 0;
    }
  }
</style>
